export default function BlogTimer(time: string, locale: string) {
    if (!time) {
        return '';
    }
    const monthText = DateMap[locale] || DateMap['us'];
    const dateA = new Date(time);
    const yearString = dateA.getFullYear();
    const monthString = `${dateA.getMonth() + 1}`;
    const dateString1 = dateA.getDate();

    return `${yearString}/${monthString}/${dateString1}`;
    //return `${monthText[monthString]} ${dateString1}, ${yearString}`;
}

export const DateMap: any = {
    us: {
        '1': 'January',
        '2': 'February',
        '3': 'March',
        '4': 'April',
        '5': 'May',
        '6': 'June',
        '7': 'July',
        '8': 'August',
        '9': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December',
    },

    de: {
        '1': 'Januar',
        '2': 'Februar',
        '3': 'März',
        '4': 'April',
        '5': 'Mai',
        '6': 'Juni',
        '7': 'Juli',
        '8': 'August',
        '9': 'September',
        '10': 'Oktober',
        '11': 'November',
        '12': 'Dezember',
    },
    it: {
        '1': 'Gennaio',
        '2': 'Febbraio',
        '3': 'Marzo',
        '4': 'Aprile',
        '5': 'Maggio',
        '6': 'Giugno',
        '7': 'Luglio',
        '8': 'Agosto',
        '9': 'Settembre',
        '10': 'Ottobre',
        '11': 'Novembre',
        '12': 'Dicembre',
    },
    pl: {
        '1': 'Styczeń',
        '2': 'Luty',
        '3': 'Marzec',
        '4': 'Kwiecień',
        '5': 'Maj',
        '6': 'Czerwiec',
        '7': 'Lipiec',
        '8': 'Sierpień',
        '9': 'Wrzesień',
        '10': 'Październik',
        '11': 'Listopad',
        '12': 'Grudzień',
    },
};
